import DuckEntity from './DuckEntity';

const billingCategories = new DuckEntity('billingCategories', {
  jsonRoot: 'billing_category'
});

/**
 * Compare function to sort billing categories for use with Array.sort().
 *
 * This should only be used for categories from the same billing category group.
 *
 * Example:
 *
 * categories.sort(billingCategoryComparator)
 *
 * @param a first category
 * @param b second second category
 * @return {number} negative value if a sorts before b, 0 if a equals b, positive value if b sorts before a
 */
const billingCategoryComparator = (a, b) => {
  if (a.parent_id !== b.parent_id) {
    return (b.parent_id == null) ? 1 : -1;
  } else if (a.category_type !== b.category_type) {
    return a.category_type === 'charge' ? -1 : 1;
  } else {
    return a.position - b.position;
  }
}

export {
  billingCategories,
  billingCategoryComparator
};
